import React from "react";
import { Reveal } from "../shared/Reveal";

export default function UNStatement() {
  return (
    <section className="unstatement" data-testid="un-statement">
      <div className="wrap">
        <Reveal className="unpanel" tag="div">
          <blockquote className="unquote">
            &ldquo;We consider Energy Efficiency to be the &lsquo;first fuel&rsquo; as it still
            represents the cleanest and, in most cases, the cheapest way to meet our energy needs.&rdquo;
          </blockquote>
          <div className="unattr">UNITED NATIONS</div>
          <img className="unemblem" src="/brand/un_emblem.png" alt="United Nations emblem" loading="lazy" />
        </Reveal>
      </div>
    </section>
  );
}
